/* Aquablue mobile UX — overlay menu (no page push) */
(function () {
  var PUSH = "cbp-spmenu-push-toright";
  var OPEN = "cbp-spmenu-open";
  var ACTIVE = "active";

  function els() {
    return {
      menu: document.getElementById("cbp-spmenu-s1"),
      btn: document.getElementById("showLeftPush"),
      body: document.body,
      html: document.documentElement,
      wrap: document.querySelector(".wrapper-container"),
    };
  }

  function forceNoPush() {
    var e = els();
    var nodes = [e.html, e.body, e.wrap].filter(Boolean);
    nodes.forEach(function (n) {
      n.style.setProperty("left", "0", "important");
      n.style.setProperty("margin-left", "0", "important");
      n.style.setProperty("transform", "none", "important");
      n.style.setProperty("-webkit-transform", "none", "important");
      n.style.setProperty("width", "100%", "important");
    });
    if (e.body && e.body.classList.contains(PUSH)) {
      e.body.style.setProperty("position", "fixed", "important");
      e.body.style.setProperty("top", "0", "important");
      e.body.style.setProperty("overflow", "hidden", "important");
      e.body.style.setProperty("height", "100%", "important");
    }
    if (e.menu) {
      e.menu.style.setProperty("position", "fixed", "important");
      e.menu.style.setProperty("z-index", "1002", "important");
    }
  }

  function clearInline() {
    var e = els();
    [e.html, e.body, e.wrap].filter(Boolean).forEach(function (n) {
      ["left", "margin-left", "transform", "-webkit-transform", "width", "position", "top", "overflow", "height"].forEach(function (p) {
        n.style.removeProperty(p);
      });
    });
    if (e.menu) {
      e.menu.style.removeProperty("position");
      e.menu.style.removeProperty("z-index");
    }
  }

  function closeMenu() {
    var e = els();
    if (!e.menu || !e.btn) return;
    if (window.classie) {
      classie.remove(e.btn, ACTIVE);
      classie.remove(e.body, PUSH);
      classie.remove(e.menu, OPEN);
    } else {
      e.btn.classList.remove(ACTIVE);
      e.body.classList.remove(PUSH);
      e.menu.classList.remove(OPEN);
    }
    clearInline();
  }

  function onToggle() {
    // Run after classie.toggle in the theme handler
    setTimeout(function () {
      var e = els();
      if (e.body && e.body.classList.contains(PUSH)) {
        forceNoPush();
      } else {
        clearInline();
      }
    }, 0);
  }

  function bind() {
    var e = els();
    if (!e.btn) return;

    // Capture-phase hook so we run around theme onclick
    e.btn.addEventListener("click", onToggle, true);
    e.btn.addEventListener("click", onToggle, false);

    // If theme set onclick property, wrap it
    if (typeof e.btn.onclick === "function") {
      var orig = e.btn.onclick;
      e.btn.onclick = function (ev) {
        var ret = orig.call(this, ev);
        onToggle();
        return ret;
      };
    }

    // MutationObserver: whenever PUSH class appears, force left:0
    var obs = new MutationObserver(function () {
      if (document.body.classList.contains(PUSH)) {
        forceNoPush();
      }
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });
  }

  // Outside / overlay tap closes
  document.addEventListener(
    "click",
    function (ev) {
      if (!document.body.classList.contains(PUSH)) return;
      var e = els();
      if (e.menu && e.menu.contains(ev.target)) return;
      if (e.btn && (e.btn === ev.target || e.btn.contains(ev.target))) return;
      closeMenu();
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  // Theme footer script may assign onclick after us — re-bind shortly after
  setTimeout(bind, 100);
  setTimeout(bind, 500);
})();
